export const IGNORED_EXCEPTION_MESSAGES = [
  "member called after shutdown",
  "Uncaught ReferenceError: member called after shutdown",
  "Incompatible load types.",
  "Cannot pick from outside the canvas area.",
  "ResizeObserver loop",
  "ResizeObserver loop completed with undelivered notifications",
  // Sentry errors cause by vite:preloadError
  "dynamically imported module",
  "Importing a module script failed",
  "Failed to load module script",
  "Unable to preload CSS",
  // expo-location rejection when the user has denied location permission
  "Location permission is required to do this operation",
  // expo-location failures (GPS unavailable, timeout, permission)
  "Calling the 'getCurrentPositionAsync' function has failed",
  // expo-image-picker iOS failure reading a photo-library asset (e.g. iCloud-offloaded)
  "Failed to read picked image",
  "with a width or height of 0",
];

export const HOOPS_STACK_MARKERS = ["vendor-hoops", "hoops-web-viewer"];
export function isHoopsError(err: unknown): boolean {
  const isObject = typeof err === "object" && err !== null;
  // `err` is an arbitrary caught value / window error payload, so probe for `stack` and
  // `filename` by presence instead of asserting it into Error / ErrorEvent.
  const candidates: unknown[] = [
    typeof err === "string" ? err : undefined,
    isObject && "stack" in err ? err.stack : undefined,
    isObject && "filename" in err ? err.filename : undefined,
  ];
  return candidates.some(
    (candidate) => typeof candidate === "string" && HOOPS_STACK_MARKERS.some((marker) => candidate.includes(marker)),
  );
}
